import { ajax } from '@utils/ajax';
import { AxiosPromise } from 'axios';

export function fileSectionsAPI(endpoint: string): AxiosPromise {
	return ajax.get(endpoint);
}
